import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { BatchItemResultDto } from './batch-item-result-dto';
import { BatchResultDto } from './batch-result-dto';
const ɵ0 = () => BatchItemResultDto;
export class BatchDetailResultDto extends BatchResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], BatchDetailResultDto.prototype, "items", void 0);
export { ɵ0 };
